import React, { useState } from 'react'

import { UpdateClientStatus } from 'store/ClientsApiClient'
import { trackPromise } from 'react-promise-tracker'
import LoadingWrapper from 'components/LoadingWrapper'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

const CancelLink = styled.span`
    padding-left: 15px;
`

const SecondaryTitle = styled.p`
    padding-top: 30px;
    margin-bottom: -10px;
`

const ChangeStatusModal = ({ clientId, close, refreshList, firstName, lastName, nextStatuses }) => {
    const PromiseArea = 'change-client-status'
    const [error, setError] = useState(null)
    const [selectedPrimaryStatus, setSelectedPrimaryStatus] = useState(null)
    const [secondaryStatusOptions, setSecondaryStatusOptions] = useState(null)
    const [secondaryStatusDescription, setSecondaryStatusDescription] = useState(null)
    const [annualizedPremium, setAnnualizedPremium] = useState(null)
    //client

    const ChangeStatus = (status, secondaryStatus) => {
        if (status === 'ApprovalCasePlaced' && !secondaryStatus) {
            setSelectedPrimaryStatus(status)
            setSecondaryStatusDescription('What is the final annualized premium?')
            setSecondaryStatusOptions(['Submit to Goal Tracker'])
        } else {
            let noPlanReason = null
            let planType = null
            let premium = annualizedPremium

            setSecondaryStatusOptions(null)
            setSecondaryStatusDescription(null)
            setAnnualizedPremium(null)

            trackPromise(
                UpdateClientStatus(clientId, status, noPlanReason, planType, premium)
                    .then(() => {
                        close()
                        refreshList()
                    })
                    .catch((ex) => {
                        console.error(ex)
                        setError('There was a problem saving the client')
                    }),
                PromiseArea
            )
        }
    }

    return (
        <>
            <div id="modal-cover"></div>
            <div id="delete-modal" className="modal">
                <LoadingWrapper area={PromiseArea}>
                    <h5>
                        Change Status for {firstName} {lastName}
                    </h5>
                    <p>{nextStatuses.primaryText}</p>
                    {error && <p>{error}</p>}

                    <div className="modal-buttons">
                        {nextStatuses.availableStatuses &&
                            nextStatuses.availableStatuses.map((status) => {
                                return (
                                    <button
                                        key={status.status}
                                        className={
                                            status === selectedPrimaryStatus
                                                ? 'btn selected'
                                                : 'btn'
                                        }
                                        onClick={() => {
                                            ChangeStatus(status.status)
                                        }}
                                    >
                                        {status.description}
                                    </button>
                                )
                            })}
                        <CancelLink onMouseDown={close}>CANCEL</CancelLink>
                    </div>
                    {secondaryStatusOptions && (
                        <>
                            <SecondaryTitle>{secondaryStatusDescription}</SecondaryTitle>
                            <div className="modal-buttons">
                                {secondaryStatusOptions.map((secondaryStatus) => {
                                    return (
                                        <React.Fragment key={secondaryStatus}>
                                            <NumberFormat
                                                prefix="$"
                                                thousandSeparator=","
                                                allowNegative={false}
                                                decimalScale={2}
                                                value={annualizedPremium}
                                                type="text"
                                                onValueChange={(values) => {
                                                    setAnnualizedPremium(values.value)
                                                }}
                                                placeholder="Annual Premium"
                                            />
                                            <button
                                                key={secondaryStatus}
                                                className="btn"
                                                onClick={() => {
                                                    ChangeStatus(
                                                        selectedPrimaryStatus,
                                                        secondaryStatus
                                                    )
                                                }}
                                            >
                                                {secondaryStatus}
                                            </button>
                                        </React.Fragment>
                                    )
                                })}
                            </div>
                        </>
                    )}
                </LoadingWrapper>
            </div>
        </>
    )
}

export default ChangeStatusModal
